<template>
    <router-view id="app" />
</template>

<script>
export default {
  name: 'App',
  created() {
    if ( ! this.$store.getters.isProfileComplete) {
      // this.$router.push({ name: 'CreateProfile' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue